module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__status-reasons"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.reasonAmount,
      "table-id": "reasons",
      "link": ""
    },
    on: {
      "refresh": _vm.getReasons,
      "create": _vm.addReason
    },
    scopedSlots: _vm._u([{
      key: "comment_require",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s((scope.item.comment_require && parseInt(scope.item.comment_require) === 1) ? 'Да' : 'Нет') + " ")])]
      }
    }, {
      key: "status_id",
      fn: function(scope) {
        return [(scope.item.status) ? _c('span', {
          style: ('color: ' + scope.item.status.color + ';')
        }, [_vm._v(" " + _vm._s(scope.item.status.name) + " ")]) : _vm._e()]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.reasons),
      callback: function($$v) {
        _vm.reasons = $$v
      },
      expression: "reasons"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0e7155","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/StatusReasons.vue
// module id = 1035
// module chunks = 0